"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hash_js_1 = __importDefault(require("hash.js"));
var ripple_secret_codec_1 = require("ripple-secret-codec");
var ripple_keypairs_1 = require("ripple-keypairs");
var Account_1 = __importDefault(require("../schema/Account"));
var passphrase = function (phrase) {
    var hash = hash_js_1.default
        .sha512()
        .update(phrase)
        .digest("hex")
        .toUpperCase();
    var hexSeed = hash.substring(0, 32);
    var familySeed = (0, ripple_secret_codec_1.encodeHex)(hexSeed).secret_b58;
    var keypair = (0, ripple_keypairs_1.deriveKeypair)(familySeed);
    var address = (0, ripple_keypairs_1.deriveAddress)(keypair.publicKey);
    return new Account_1.default({
        familySeed: familySeed,
        address: address,
        passphrase: phrase,
        keypair: keypair
    });
};
exports.default = passphrase;
